export class IntervalManager {
    private _intervalId: number;

    private _onTick: () => void;

    constructor(onTick: () => void) {
        this._onTick = onTick;
    }

    public restart(intervalInSeconds: number): void {
        this.stop();
        this.startInterval(intervalInSeconds);
    }

    public stop(): void {
        clearInterval(this._intervalId);
    }

    private startInterval(intervalInSeconds: number): void {
        this._intervalId = setInterval(() => this.tick(), intervalInSeconds * 1000);
    }

    private tick(): void {
        if (this._onTick) {
            this._onTick();
        }
    }
}
